import {useAppSelector} from './store';

export function useAuth(){
    const {isAuthorized} = useAppSelector(state => state.auth);
    return {isAuthorized};
}
